// removed by extract-text-webpack-plugin
module.exports = {"OrderDetailPage":"OrderDetailPage__OrderDetailPage__1qHba","DetailCard":"OrderDetailPage__DetailCard__35OLU","DetailWrapper":"OrderDetailPage__DetailWrapper__1jOc5","DetailHeader":"OrderDetailPage__DetailHeader__193vl","CardRow":"OrderDetailPage__CardRow__2ml2I","OrderDetailPageTitle":"OrderDetailPage__OrderDetailPageTitle__1IPw5","GoBack":"OrderDetailPage__GoBack__3dZEX","OrderDetailsItems":"OrderDetailPage__OrderDetailsItems__3UCX6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Order/OrderDetailPage/OrderDetailPage.css
// module id = 164
// module chunks = 0